import { render } from "./RpmAccordion.vue?vue&type=template&id=01ca677a&scoped=true"
import script from "./RpmAccordion.vue?vue&type=script&lang=js"
export * from "./RpmAccordion.vue?vue&type=script&lang=js"

import "./RpmAccordion.vue?vue&type=style&index=0&id=01ca677a&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ca677a"]])

export default __exports__